import {ArrowUpRight, CalendarDays, Tag} from 'lucide-react'
import type {HistoryRecord} from '../../history/data/mockHistory'
import {formatStatusDate, industryLabel, promotionName, valueText} from '../data/statusBoard'
import {AuthorAvatar, ValidityBadge} from './StatusBadges'

export default function StatusRecordCard({record, onOpen}: {record: HistoryRecord; onOpen: () => void}) {
  return (
    <button type='button' className='bs-card' onClick={onOpen} aria-label={`Ver detalhes de ${promotionName(record)}`}>
      <div className='bs-card-top'><span className='bs-record-id'>PRM <b>#{record.id}</b></span><ValidityBadge status={record.status} /></div>
      <h3>{promotionName(record)}</h3>
      <div className='bs-card-tags'><span className='bs-template'><Tag size={11} aria-hidden='true' />{record.templateName}</span>
        <span className='bs-industry'>{industryLabel(record.values.industria)}</span></div>
      <div className='bs-card-dates'><span className='bs-date-icon'><CalendarDays size={16} aria-hidden='true' /></span>
        <div><span>Período de vigência</span><strong>{formatStatusDate(valueText(record.values.inicioVigencia))}</strong>
          <span>até {formatStatusDate(valueText(record.values.fimVigencia))}</span></div></div>
      {record.pipefyStatus === 'sent_manual' && <span className='bs-manual'>Envio confirmado manualmente</span>}
      <div className='bs-card-footer'><AuthorAvatar name={record.author} /><span>{record.author}</span>
        <span className='bs-card-open'><ArrowUpRight size={15} aria-hidden='true' /></span></div>
    </button>
  )
}
